import { createApp } from 'vue';
import Cleave from 'cleave.js';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';

loadFonts();

const app = createApp(App);

app.directive('cleave', {
	created: (el, binding) => {
		el.cleave = new Cleave(el, binding.value || {});
	},
	updated: (el) => {
		const event = new Event('input', { bubbles: true });
		setTimeout(() => {
			el.value = el.cleave.properties.result;
			el.dispatchEvent(event);
		}, 50);
	},
});

app.use(router).use(store).use(vuetify).mount('#app');
